import { render, staticRenderFns } from "./no-access.vue?vue&type=template&id=095614e2&"
import script from "./no-access.vue?vue&type=script&lang=js&"
export * from "./no-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports